import { Col } from "@commonlibs";
import styled, { css } from "styled-components";

export const WidthLimiterLayoutRoot = styled(Col)(
    ({ theme }) => css`
        flex: 1;
        min-height: 100%;
        background: ${theme.palette.overlays["350"][12]};
    `,
);

export const MaxWidthStyles = css(
    ({ theme }) => css`
        width: 100%;
        flex: 1;

        ${theme.breakpoints.up("maxPageWidth")} {
            max-width: ${theme.breakpoints.values.maxPageWidth}px;
            border-left ${theme.border.sm};
            border-right ${theme.border.sm};
        }

        @media screen and (orientation: landscape) and (max-width: ${theme.breakpoints.values.sm}px) {
            max-width: unset;
            border: none;
        }
        `,
);

export const MaxWidthWrapper = styled(Col)(
    () => css`
        flex: 1;
        ${MaxWidthStyles}
    `,
);
